<template>
    <nav class="menu-container">
     <h3> <!-- <font color="#00AB39">E3路</font>-->深圳通</h3> 
     邮政编码：518131 <br>
传真号码：（86）755 8370 7731 <br>

服务热线：0755-86699000 <br>
APP：深圳通 <br>

<br>

办卡说明<br>

<br>

深圳通卡办卡及深圳通二维码说明<br>
　　（一）深圳通二维码<br>

　　“深圳通二维码”是由深圳通公司研发和运营，具备“深圳通”功能的应用于交通行业的二维码支付产品。深圳通二维码业务采用“先消费、后支付、免密码”的模式，节约乘车时间，改善用户体验。<br><br>

　　打开微信，进入【发现】->【小程序】,在搜索栏输入“深圳通+”，点击搜索，找到“深圳通+”小程序，点击进入。进入后输入手机号和验证码，点击登录，首次使用需绑定微信免密支付（扣款方式：零钱或微信已绑定的银行卡都可以），绑定完成后即可看到深圳通二维码。将二维码对准扫码设备进行扫码乘车。<br><br>

　　（二）普通深圳通卡办卡说明<br>

　　办理网点：深圳通客服网点、深圳地铁各站点、深圳通便民服务点以及贴有深圳通标识的便利店、社区超市、银行网点、部分地铁沿线的自助售卡机等（以下简称“深圳通代理商”）均可办理深圳通卡。深圳通卡办理网点将不断拓展，具体地点详见发卡单位在媒体和网站的公告。<br><br>

　　办理方法：从2014年1月1日起，交纳20元押金即可获得一张押金卡，押金退卡时可按规定退还；纪念卡由深圳通公司按市场需求自主定价发行。<br><br>

　　（三）学生卡办卡说明<br>

　　深圳市教育局注册、政府统一管理的全日制中小学校（含普通和职业高中）、中专学校、技工学校、职业学校18周岁以下在校学生，如不在深圳就读的则不予申办《深圳通学生卡》。相关申办事项如下：<br><br>

　　1、学生卡申办条件<br>

　　6-14周岁（不含14周岁）的中小学生由监护人（父母）代为办理，需携带监护人本人和小孩的身份证（或儿童证、户口簿、护照等其他有效证件）及学生证或在校证明（内容包括学生姓名、性别、学校名称、就读年级等）的原件。<br><br>

　　14-18周岁（不含18周岁）的中学生可携带已注册的学生证或就读学校开具的在校证明，以及身份证或其他有效证件的原件，如监护人代办还需提供监护人的身份证件原件。如不在深圳就读则不予申办深圳通学生卡。<br><br>

　　2、学生卡办理需在深圳通系统内输入学生的身份证号码。<br><br>

　　3、学生卡可在我市6个深圳通自营客服网点、95家联通自营营业厅及55家邮政支局进行办理。<br><br>

　　4、深圳通客服网点支持深圳通普通版学生卡的全业务办理。<br><br>

　　5、深圳联通营业厅支持深圳通学生卡（含普通版及异形卡）售卡、挂失、充值、查询等业务。市民可就近选择前往办理。<br><br>

　　6、深圳邮政支局支持深圳通学生卡（含普通版及异形卡）的全业务办理，市民可就近选择前往办理。<br><br>

　　7、深圳通微信公众学生卡线上办理<br><br>

　　在深圳通微信公众号（微信号：sztgzh）点击“深圳通卡”进入“学生卡办理”，按照页面提示完成资料提交，审核通过后，可携带上传证件到约定网点进行现场身份检验领卡。<br><br>

　　8、深圳通APP学生卡线上办理<br><br>

　　可通过下载深圳通APP，根据相关申请流程完成办理。<br>

　　注意事项：在联通营业厅及邮政支局办理学生卡，需提供学生的身份证原件（如由他人代办，还需提供代办人的身份证原件），如若提供其他种类的身份证件（如户口簿、居住证、社保卡等）需前往深圳通客服网点办理。<br><br>

　　（四）“深圳市残疾人乘车卡”办理说明<br>

　　本市户籍残疾人持残疾人证、身份证到户口所在社区工作站填写申办表格，由街道残联汇总报辖区残联初审盖章后上报市残联，市残联复审后交深圳通公司制作乘车卡。<br><br>

　　（五）深圳市儿童乘车卡<br>

　　1、6周岁以下（不含6周岁）的儿童，由监护人（父母）携带本人和小孩的身份证（或带有身份证号码的法定有效证件，如户口本、居住证等）的原件前往深圳通客服网点办理深圳市儿童乘车卡。<br><br>

　　2、6-14周岁（不含14周岁）儿童，参照深圳通学生卡业务进行办理。具体见《深圳市儿童乘车卡办理及使用指引》<br><br>

　　（六）深圳市优抚对象优待证<br>

　　现役军人、残疾军人和本市户籍享受抚恤补助待遇的复员军人、带病回乡退伍军人、参战涉核退役人员、烈士遗属、因公牺牲军人遗属、病故军人遗属、军队离退休干部等人员向市双拥办提出优惠卡制作申请，市双拥办审核申请人个人资料信息符合申请条件后，统一向深圳通公司申请制卡。具体见《深圳通优惠卡发行实施细则》<br><br>

　　（七）深圳通后付费卡（工行）<br>

　　深圳通后付费卡（工行）是由深圳通公司与指定银行联合发行的具有银行信用卡消费等金融服务以及与其信用卡账户绑定的深圳通自动充值及支付等功能的联名卡。该卡具有深圳通系统电子支付功能以及深圳通账户自动充值功能。具体办理及使用请参考《深圳通后付费卡发行实施细则》。<br><br>

　　（八）深圳通银行联名卡<br>

　　深圳通银行联名卡由联名卡合作银行自行设定网点进行销售，市民可通过各发行银行的宣传指示，到指定地点进行办理。具体地点详见各发卡银行机构在媒体和网站的公告。<br><br>

　　（九）手机深圳通卡<br>

　　用户根据不同的“手机深圳通”模式，携带本人手机及有效证件到通信运营商处申请办理。如用户持有定制手机，可自行开通深圳通功能。<br>


     <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
    </nav>
  </template>
  
  <script>
  import Icon from "@/components/Icon";
  export default {
    components: {
      Icon,
    },
    data() {
      return {
        items: [
          // 模板         {
          //  name: "azhan",
          //  title: "A站",
          //  icon: "chat",
          //  exact: true,
          //  },
  // 
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
          // {
            // name: "",
            //  title: "",
            // icon: "chat",
            // exact: true,
          // },
        ],
      };
    },
  };
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(67, 47, 221);
      }
    }
  }
  </style>
  
  
  
  
  
  